export default __webpack_public_path__ + "static/media/project1.89fb2088.png";